const medicalFacilities = [
    {
        id: "emergency",
        title: "Emergency & First Aid",
        image: "/images/Department/Emergency.jpg",
        motto: "Immediate care when it matters most",
        overview:
            "We provide prompt emergency and first aid support for accidents, injuries, sudden illness, and urgent medical needs.",
        services: [
            "Emergency first aid",
            "Accident & injury care",
            "Immediate stabilization",
            "Referral support if required",
            "CPR and basic life support",
            "Trauma management",
        ],
    },
    {
        id: "general-care",
        title: "General Medical Care",
        image: "/images/Department/medicine.jpg",
        motto: "Care for everyday health problems",
        overview:
            "General medical consultation and treatment for common illnesses and routine health concerns.",
        services: [
            "Fever & infections",
            "BP & sugar check",
            "General OPD consultation",
            "Routine health checkup",
            "Cold and flu treatment",
            "Diet and lifestyle guidance",
        ],
    },
    {
        id: "heart-care",
        title: "Heart Health Support",
        image: "/images/Department/Cardiology.jpg",
        motto: "Basic heart care & guidance",
        overview:
            "Basic heart health consultation, monitoring, and guidance with referral support if needed.",
        services: [
            "BP monitoring",
            "ECG coordination",
            "Heart health evaluation",
            "Cholesterol check",
            "Heart risk assessment",
            "Medication guidance",
        ],
    },
    {
        id: "child-care",
        title: "Child Care Services",
        image: "/images/Department/pediatrics.jpg",
        motto: "Gentle care for children",
        overview:
            "Healthcare services for infants and children focusing on common illnesses and routine checkups.",
        services: [
            "Child illness treatment",
            "Vaccination guidance",
            "Newborn care advice",
            "Growth monitoring",
            "Nutritional counseling",
            "Allergy management",
        ],
    },
    {
        id: "women-care",
        title: "Women’s Health Care",
        image: "/images/Department/Obstetrics.jpg",
        motto: "Supporting women at every stage",
        overview:
            "Consultation and guidance for women’s health, pregnancy care, and routine gynecological concerns.",
        services: [
            "Antenatal checkups",
            "Women’s health issues",
            "Pregnancy guidance",
            "Menstrual disorder management",
            "Family planning advice",
            "Postnatal care",
        ],
    },
    {
        id: "bone-care",
        title: "Bone & Joint Care",
        image: "/images/Department/Orthopedics.jpg",
        motto: "Helping you move better",
        overview:
            "Consultation and care for bone, joint, muscle pain, and mobility-related problems.",
        services: [
            "Fracture first care",
            "Joint & back pain",
            "Orthopedic consultation",
            "Physiotherapy guidance",
            "Arthritis management",
            "Bone density check",
        ],
    },
    {
        id: "minor-procedures",
        title: "Minor Procedures & Dressing",
        image: "/images/Department/General-surgery.jpg",
        motto: "Safe & hygienic procedures",
        overview:
            "Minor medical procedures performed with safety, hygiene, and trained medical staff.",
        services: [
            "Wound dressing",
            "Injections & IV fluids",
            "Minor procedures",
            "Suturing of cuts",
            "Removal of stitches",
            "Local anesthesia procedures",
        ],
    },
    {
        id: "diagnostic-support",
        title: "Basic Diagnostic Support",
        image: "/images/Department/Radiology.jpg",
        motto: "Supporting accurate diagnosis",
        overview:
            "Basic diagnostic coordination and report support to assist proper treatment decisions.",
        services: [
            "X-ray coordination",
            "Basic investigations",
            "Ultrasound coordination",
            "ECG reporting",
            "Blood pressure tests",
            "Basic imaging support",
        ],
    },
    {
        id: "lab-support",
        title: "Pathology Support",
        image: "/images/Department/Pathology.jpg",
        motto: "Reliable reports for better care",
        overview:
            "Pathology test coordination and report review for accurate medical evaluation.",
        services: [
            "Blood & urine tests",
            "Routine lab investigations",
            "Biochemistry tests",
            "Hematology analysis",
            "Microbiology tests",
            "Report interpretation support",
        ],
    },
    {
        id: "respiratory-care",
        title: "Respiratory Care",
        image: "/images/Department/pulmonary.jpg",
        motto: "Helping you breathe easy",
        overview:
            "Care and consultation for common respiratory problems with proper medical guidance.",
        services: [
            "Asthma care",
            "Chest infection treatment",
            "COPD management",
            "Breathing exercises guidance",
            "Oxygen therapy advice",
            "Pulmonary function tests",
        ],
    },
];

export default medicalFacilities;
